import { errorLogger as error } from './error';
import { infoLogger as info } from './info';
import { getError } from './getError';
// import { getCallStack } from './getCallStack';

export const logger = {
  error,
  info,
  getError,
  // getCallStack,
};
